import { useQuery } from '@apollo/client';
import { PaymentGetCardDetailsQuery } from '__generated__/graphql';
import { GET_CHECKOUT_DOT_COM_CARDS } from '../graphql/getCheckoutDotComCards';

export function useGetCheckoutDotComCards(props?: { skip?: boolean }) {
  const { data, error, loading, refetch } = useQuery<PaymentGetCardDetailsQuery>(GET_CHECKOUT_DOT_COM_CARDS, {
    skip: props?.skip,
  });

  return { data, error, loading, refetch };
}
